import React from 'react';
import styles from '../../css/components/overlays/darkFullScreenOverlay.css';
import PropTypes from 'prop-types';

function DarkFullScreenOverlay({ children }) {

	return (
		<div className={styles.overlay}>
			{children}
		</div>
	);
}

export default DarkFullScreenOverlay;

DarkFullScreenOverlay.propTypes = {
	children: PropTypes.element.isRequired,
};
